import guideCharacterSrc from "./guide-character.webp";

/**
 * サイト共通の案内役キャラクター。
 * Instagram「スマホ代見直し案内所」と同じ人物・画風の1枚を、サイト全体で使い回す。
 * 実在の専門家や運営者本人ではなく、料金整理を手伝う案内役として扱う。
 */
export const GUIDE_CHARACTER = {
  src: guideCharacterSrc,
  width: 1122,
  height: 1402,
  alt: "請求書とスマートフォンを見ながら、スマホ料金の整理を案内するキャラクター",
};

export const GUIDE_BUBBLE_HERO = "スマホ代は、まず4つに分ければ大丈夫です";
